import ClassicExtension from "./ClassicExtension";
import { Naja } from "naja";

export default class InfiniteScrollExtension extends ClassicExtension {
    private naja: Naja;

    private infinityScrollElementsReadyMap: Map<JQuery, boolean> = new Map();

    public initialize(naja: Naja): void {
        this.naja = naja;
        super.initialize(naja);

        $(window).on('scroll', () => this.onScroll());
    }

    protected init($root: JQuery): void {
        this.updateScrollElements($root);
        this.onScroll();
    }


    /**
     * Remove detached scroll elements and add new from $root
     */
    private updateScrollElements($root: JQuery): void {

        this.infinityScrollElementsReadyMap.forEach((ready, $scrollElement) => {
            if (!document.contains($scrollElement[0])) {
                this.infinityScrollElementsReadyMap.delete($scrollElement);
            }
        });

        $root.find("[data-infinite-scroll]").each((i, el) => {
            this.infinityScrollElementsReadyMap.set($(el), true);
        });
    }

    /**
     * Make ajax request when scroll touches bottom of infinity-scroll element
     */
    private onScroll(): void {
        this.infinityScrollElementsReadyMap.forEach((ready, $scrollElement) => {

            // Request already fired / does not meet infinity-scroll conditions
            if (!ready) {
                return;
            }

            // Condition: Has infinity-scroll element load button?
            const selector = $scrollElement.data('load-button');
            if (!selector) {
                this.infinityScrollElementsReadyMap.set($scrollElement, false);
                return;
            }

            // Condition: Has load button url?
            const $loadButton = $(selector);
            const url = $loadButton.attr('href');
            if (!url) {
                this.infinityScrollElementsReadyMap.set($scrollElement, false);
                return;
            }

            // Is scroll touches bottom?
            if ( $(window).scrollTop() + $(window).innerHeight() < $scrollElement.innerHeight()) {
                return;
            }


            this.infinityScrollElementsReadyMap.set($scrollElement, false);

            this.naja.makeRequest(
                'GET',
                url,
                null,
                { history: false }
            ).finally(() => {
                this.infinityScrollElementsReadyMap.set($scrollElement, true);
            });

        });
    }
}
